import { state, getters } from './state';
// import { actions, mutations } from "./action";
export default { namespaced: true, state, getters };
